/** Plain `yyyy-MM-dd` date helpers (the contract's date format). No time zone logic: a date is a calendar day. */

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

export function addDays(iso: string, days: number): string {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

export function dayAfter(iso: string): string {
  return addDays(iso, 1);
}

/** `2026-10-24` -> `Oct 24, 2026` (a calendar date, shown without time zone shifting). */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return iso;
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const t = new Date(iso);
  if (Number.isNaN(t.getTime())) return iso;
  return t.toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

const USD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
export function formatMoney(value: number | null | undefined): string {
  return value === null || value === undefined ? '' : USD.format(value);
}

export function formatPercent(value: number | null | undefined): string {
  return value === null || value === undefined ? '' : `${value}%`;
}
